import { lazy, Suspense } from 'react'

import { IActionFormProps } from '@makyoapp/makyo-common'

import { AdvanceActionInputProps } from './AdvanceActionInput'

const AdvanceActionInput = lazy(() =>
  import('@/components/ActionInputV3/AdvanceActionInput').then((mod) => ({ default: mod.AdvanceActionInput }))
)
const ActionInputV2 = lazy(() =>
  import('@/components/ActionInputV2/ActionInputV2').then((mod) => ({ default: mod.ActionInputV2 }))
)

const LoadingPlaceholder = () => (
  <div className='space-y-4 animate-pulse'>
    <div className='p-4'>
      <div className='flex gap-6'>
        <div className='w-[25%] h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
        <div className='w-full h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
      </div>
    </div>
    <div className='px-4 py-2 border-t flex justify-between items-center'>
      <div className='w-[80px] h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
      <div className='w-[80px] h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
    </div>
  </div>
)

type ActionInputProps = IActionFormProps['initialData'] & AdvanceActionInputProps

/**
 * ActionInputV3
 *
 * This component acts as a dynamic adapter for rendering either the advanced or standard action input components
 * based on the `isActionWorkflow` prop. It uses React.lazy and Suspense to load the appropriate input component
 * asynchronously, displaying a loading placeholder while the component is being loaded.
 */

export const ActionInputV3 = ({ options, isActionWorkflow, ...rest }: ActionInputProps) => {
  if (isActionWorkflow) {
    return (
      <Suspense fallback={<LoadingPlaceholder />}>
        <AdvanceActionInput {...rest} options={options ?? []} />
      </Suspense>
    )
  }
  return (
    <Suspense fallback={<LoadingPlaceholder />}>
      <ActionInputV2 {...rest} />
    </Suspense>
  )
}
